import script from "./MapaComunidad.vue?vue&type=script&setup=true&lang=js"
export * from "./MapaComunidad.vue?vue&type=script&setup=true&lang=js"

import "./MapaComunidad.vue?vue&type=style&index=0&id=4961d33c&scoped=true&lang=css"
import "./MapaComunidad.vue?vue&type=style&index=1&id=4961d33c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4961d33c"]])

export default __exports__